var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hit-container hit-html-html"},[_c('div',{staticClass:"hit-container hit-html-html"},[_c('div',{staticClass:"hit-row"},[_c('div',{staticClass:"hit-col-md-12"},[_c('div',{staticClass:"hit-alert hit-alert-success"},[_vm._v(_vm._s(_vm.$t("message.successfullValidated")))])])])]),_c('vote_conflict')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }